import { exibe_mensagem_com_status } from './toast.js';
import { close_toast } from './close.js';
import { handleIntervalTemporizadorToast } from './timer.js';
import { DEFAULT_TIMER_DURATION } from './config.js';

export { exibe_mensagem_com_status, close_toast };

Object.assign(window, {
  exibe_mensagem_com_status,
  close_toast
});

function initializeExistingToasts() {
  if (typeof window.$ === 'undefined' || typeof window.jQuery === 'undefined') {
    setTimeout(initializeExistingToasts, 50);
    return;
  }

  const toastsWithTimer = document.querySelectorAll('.maino-toast .toast-container');

  toastsWithTimer.forEach((toastContainer) => {
    const toast = toastContainer.closest('.maino-toast');
    if (!toast || toast.dataset.timerInitialized) return;

    const $toast = window.$(toast);
    if ($toast.data('timer')) return;

    const progressBarInner = toast.querySelector('.progress-bar-inner');
    if (!progressBarInner) return;

    toast.dataset.timerInitialized = 'true';

    const updateProgress = percent => {
      if (progressBarInner && progressBarInner.parentElement) {
        progressBarInner.style.width = `${percent}%`;
      }
    };

    const timer = handleIntervalTemporizadorToast(
      DEFAULT_TIMER_DURATION,
      updateProgress,
      close_toast
    );

    $toast.data('timer', timer);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeExistingToasts);
} else {
  initializeExistingToasts();
}
